import React, { useState, useEffect } from 'react';
import NavBarHome from '../Layouts/NavBarHome';
import FooterHome from '../Layouts/FooterHome';

const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  mainSection: {
    padding: '50px 20px',
    textAlign: 'center',
    backgroundColor: '#f9f9f9',
    flex: '1',
  },
  title: {
    fontSize: '48px',
    color: '#333',
    marginBottom: '20px',
    fontWeight: 'bold',
  },
  contentText: {
    fontSize: '16px',
    color: '#666',
    lineHeight: '1.6',
    maxWidth: '800px',
    margin: '10px auto',
    textAlign: 'justify',
    whiteSpace: 'pre-wrap',
    fontWeight: 'normal',
  },
};

function CaseStudiesPage() {
  console.log('✅ CaseStudiesPage loaded');

  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  return (
    <div style={styles.container}>
      <NavBarHome language={language} />

      <main style={styles.mainSection}>
        <h1 style={styles.title}>Casos de Uso</h1>
        <p style={styles.contentText}>
          Descubre cómo otras organizaciones han utilizado nuestra plataforma
          para resolver desafíos reales. En esta sección encontrarás estudios de
          caso detallados, con métricas, contextos y resultados concretos que
          demuestran el impacto de la inteligencia artificial aplicada de forma
          estratégica.
          {'\n\n'}
          Aprende de experiencias reales y encuentra inspiración para tus
          propios proyectos.
        </p>
      </main>

      <FooterHome language={language} setLanguage={setLanguage} />
    </div>
  );
}

export default CaseStudiesPage;
